import React from 'react';
import { ImageIcon, Stack } from '@fluentui/react';
import msLogo from './images/Grid.svg';

export const ShellLogo = (): JSX.Element => (
  <Stack tokens={{ padding: 8 }}>
    <ImageIcon imageProps={{ src: msLogo }} />
  </Stack>
);
